export const GET_LOOKUP_LIST = "GET_LOOKUP";
export const GET_REFERRAL_DOC = "GET_REFERRAL_DOC";
